module.exports = __webpack_public_path__ + "static/media/Diomedes.8dbfdbe7.jpg";